/**
 * Account-related constants
 */

// Default groups to initialize if none exist
export const DEFAULT_ACCOUNT_GROUPS: readonly { name: string; order: number }[] = [
  { name: "Cash", order: 0 },
  { name: "Accounts", order: 1 },
  { name: "Cards", order: 2 },
  { name: "Overdrafts", order: 3 },
  { name: "Debts", order: 4 },
] as const;
